import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Select } from '../../models/select';
import { ProducersService } from '../../services/producers.service';

@Component({
  selector: 'app-producer-finder',
  templateUrl: './producer-finder.component.html',
  styleUrls: ['./producer-finder.component.css']
})
export class ProducerFinderComponent implements OnInit {
  @Output() producerSelection = new EventEmitter();
  @Input() required = false;

  producers: any[];
  selected = false;
  textAutocomplete = {} as Select;

  @Input() dataResultEvent?: Observable<Select>;
  private eventsSubscription: Subscription;

  constructor(private producersService: ProducersService) { }

  ngOnInit(): void {
    if (this.dataResultEvent !== undefined) {
      this.eventsSubscription = this.dataResultEvent.subscribe((producer: Select) => {
        this.selected = true;
        this.textAutocomplete = producer;
      });
    }
  }

  ngOnDestroy() {
    if (this.eventsSubscription !== undefined) {
      this.eventsSubscription.unsubscribe();
    }
  }

  searchProducer(event) {
    this.producerSelection.emit(undefined);
    this.selected = false;
    this.producersService.search(event.query).subscribe(data => {
      this.producers = data;
    });
  }

  selectProducer(event) {
    this.selected = true;
    this.producerSelection.emit(event);
  }

  clearProducer(event) {
    this.selected = false;
    this.producerSelection.emit(undefined);
  }
}
